import { useForm, UseFormProps, UseFormReturn, FieldValues } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

export function useZodForm<TSchema extends z.ZodType<FieldValues, FieldValues>>(
  schema: TSchema,
  props?: Omit<UseFormProps<z.infer<TSchema>>, 'resolver'>
): UseFormReturn<z.infer<TSchema>> {
  return useForm<z.infer<TSchema>>({
    ...props,
    // Framework interop: zodResolver's Zod v4 input/output type distinction
    // doesn't align with react-hook-form's expected Resolver generic.
    // For form schemas (no transforms), input ≡ output.
    resolver: zodResolver(schema) as UseFormProps<z.infer<TSchema>>['resolver'],
  });
}
